import { render } from "./FinalPage.vue?vue&type=template&id=4d745aa0&scoped=true"
import script from "./FinalPage.vue?vue&type=script&lang=js"
export * from "./FinalPage.vue?vue&type=script&lang=js"

import "./FinalPage.vue?vue&type=style&index=0&id=4d745aa0&scoped=true&lang=scss"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d745aa0"]])

export default __exports__